import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { catalogQuery } from "../rollenmodellApi";
import { Smartphone, Wrench, BarChart3, Settings, ChevronRight } from "lucide-react";

const ICONS = { smartphone: Smartphone, wrench: Wrench, "bar-chart": BarChart3, settings: Settings };

export default function RollenStart() {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useQuery({ queryKey: ["rollenmodell-catalog"], queryFn: catalogQuery });
  const roles = data?.roles;

  return (
    <div className="container-wd py-8" data-testid="rollen-start-page">
      <span className="badge-hero" style={{ background: "#FFF7ED", borderColor: "#FED7AA", color: "#C2410C" }}>WhatsDown-Rollenmodell</span>
      <h1 className="text-3xl sm:text-4xl font-extrabold mt-3">Rollen, User Stories &amp; Abnahme</h1>
      <p className="text-base mt-2 mb-6" style={{ color: "#64748B", maxWidth: 720 }}>
        Wähle eine Rolle, um die zugehörigen User Stories, Prüffragen und die Abnahme-Checkliste zu öffnen.
        Abgehakte Punkte werden gespeichert.
      </p>

      {isError && (
        <div className="card-wd p-5 mb-4" style={{ borderColor: "#DC2626" }} data-testid="rollen-start-error">
          <p className="text-sm font-semibold m-0" style={{ color: "#DC2626" }}>Rollenmodell konnte nicht geladen werden.</p>
        </div>
      )}

      {isLoading && <p className="text-sm" style={{ color: "#64748B" }} data-testid="rollen-start-loading">Laden…</p>}

      {roles && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="rollen-start-grid">
          {roles.map((r) => {
            const Icon = ICONS[r.icon] || Wrench;
            const { total, done } = r.progress;
            const pct = total ? Math.round((done / total) * 100) : 0;
            return (
              <button key={r.key} data-testid={`rollen-card-${r.key}`}
                onClick={() => navigate(`/rolle/${r.key}`)}
                className="card-wd p-0 text-left overflow-hidden transition-transform hover:-translate-y-1"
                style={{ cursor: "pointer", border: `1px solid ${r.border}` }}>
                <div className="flex items-center gap-3 px-5 py-4" style={{ background: r.bg, borderBottom: `1px solid ${r.border}` }}>
                  <Icon size={22} color={r.color} />
                  <span className="text-lg font-extrabold" style={{ color: r.color }}>{r.label}</span>
                </div>
                <div className="p-5">
                  <p className="text-sm font-bold m-0">{r.story_count} User Stories</p>
                  <p className="text-sm mt-1" style={{ color: "#64748B" }}>{r.summary}</p>
                  <div className="mt-4">
                    <div className="flex justify-between text-xs mb-1" style={{ color: "#64748B" }}>
                      <span>Abnahme</span>
                      <span data-testid={`rollen-progress-${r.key}`}>{done}/{total}</span>
                    </div>
                    <div className="w-full rounded-full" style={{ height: 8, background: "#E2E8F0" }}>
                      <div style={{ height: 8, width: `${pct}%`, background: r.color, borderRadius: 999, transition: "width .3s" }} />
                    </div>
                  </div>
                  <div className="flex items-center gap-1 mt-4 text-sm font-semibold" style={{ color: r.color }}>
                    Öffnen <ChevronRight size={16} />
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
